import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleInfo"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V19H8.74274L11.9951 21.7263L15.2858 19H21V3ZM12.75 15V9.5H11.25V15H12.75ZM12.75 8.5H11.25V7H12.75V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleInfo;
